module.exports = {"common":{"login":"Login","logout":"Logout","exit":"Exit"},"action":{"operation":"Operation","view":"View","add":"Add","edit":"Edit","delete":"Delete","batchDelete":"Batch Delete","search":"Search","loading":"loading","submit":"Submit","comfirm":"Comfirm","cancel":"Cancel","reset":"Reset","save":"Save"},"tips":{"successOper":"Successful operation","successRev":"Successful revision","successDel":"Successful deletion","successSub":"Successful submission"},"menu":{"set":"Business Card Set","businessCard":"Business Card"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs/en.json
// module id = f7hK
// module chunks = 174